import { LEASE_DEALS_SUPPORTED_CAR_TYPES } from 'site-modules/upper-funnel/constants/hidden-gems-supported-types';

export const isLeaseDealsLinkEligible = carType => {
  return LEASE_DEALS_SUPPORTED_CAR_TYPES.includes(carType);
};
